import { updatePassword } from "@/api/Login";
import { defineStore } from "pinia";
import { ref } from "vue";

export const captionTtsStore = defineStore("state", {
    state:()=> ({
        isOpen:false,//是否打开幻音TTS
        isHaveTranslation:false,//是否有翻译文本
        isDubbing:false,//是否开启翻译配音
        isloadDubbing:false,//翻译配音加载状态
        translationStatus:0,//翻译配音状态
        isHeightLight:false,//是否高亮显示配音文本
        ttsListData:[],//字幕音频数据
        roleList:[],//角色列表
        textList:[],//文本列表
        textId:'',//当前操作文本ID
        voiceRoles:[],//当前文本角色列表

    }),
      actions: {
        toOpen() {
            this.isOpen=true
            return true
        },
        toClose(){
            this.isOpen=false
            return false
        },
        toInit(){
            this.isOpen=false
            this.isDubbing=false
            this.isHeightLight=false
            this.ttsListData=[]
            this.isloadDubbing=false
            this.translationStatus=0
        },
        dubbingOpen(){
            this.isDubbing=true
            return true
        },
        dubbingClose(){ 
            this.isDubbing=false
            return false
        },
        heightLightOpen(){
            this.isHeightLight=true
            return true
        },
        heightLightClose(){
            this.isHeightLight=false
            return false
        },  
        updataTranslatState(data:any){
            this.isHaveTranslation=data
        } ,
        updatattsListData(data:any){
            this.ttsListData=data
        },
        updataTextList(data:any){
            this.textList=data
        },
        loadState(data:boolean){
            this.isloadDubbing=data 
        },
        updataRoleList(data:any){
            this.roleList=data
        },
        updataTextId(data:string){
            this.textId=data    
        },
        updateTranslationStatus(data:number){
            this.translationStatus=data
        },
        updataVoiceRoles(data:any){
            this.voiceRoles=data
        }


    },        
  });

